import { useMemo, useState } from "react";
import { Button, Form, Popup } from "semantic-ui-react";
import { toast } from "../..";
import { UserData } from "../../actions/authentificationActions";
import { changeUserPassword } from "../../services/userService";

export interface ChangePasswordDto {
    userGuid: string;
    oldPassword: string;
    newPassword1: string;
    newPassword2: string;
}

interface IProps {
    user: UserData;
    adminResetMode?: boolean;
    passwordChanged?: () => void;
}

export const ChangePassword = ({ user, adminResetMode, passwordChanged }: IProps) => {
    const [changePasswordDto, setChangePasswordDto] = useState<ChangePasswordDto>({
        userGuid: user.guid!,
        oldPassword: "",
        newPassword1: "",
        newPassword2: "",
    });
    const [saving, setSaving] = useState(false);
    const isEnabled = useMemo(() => {
        return (
            changePasswordDto.newPassword1.length > 0 &&
            changePasswordDto.newPassword2.length > 0 &&
            changePasswordDto.newPassword1 === changePasswordDto.newPassword2
        );
    }, [changePasswordDto]);

    const handleChangeInput = (e: any) =>
        setChangePasswordDto({ ...changePasswordDto, [e.target.name]: e.target.value });

    const handleUpdatePassword = async () => {
        setSaving(true);
        const res = await changeUserPassword(changePasswordDto);
        if (res.ok) {
            setChangePasswordDto({
                userGuid: user.guid!,
                oldPassword: "",
                newPassword1: "",
                newPassword2: "",
            });
            toast("Successfully changed password", true);
            passwordChanged?.(); // Callback function if provided
        } else toast(await res.text(), false, 10000);
        setSaving(false);
    };

    return (
        <div id="change-password-container" className="change-password-container">
            <h2 id="h2-tsc-blue-changePassword" className="tsc-blue">
                Change password
            </h2>
            <Form id="change-password-form-a" className="change-password-form">
                {!adminResetMode && (
                    <Form.Field id="form-field-changePassword-a">
                        <label id="old-password-changePassword">Old password</label>
                        <input
                            id="input-changePassword-a"
                            name="oldPassword"
                            value={changePasswordDto.oldPassword}
                            type="password"
                            onChange={handleChangeInput}
                        />
                    </Form.Field>
                )}
                <Form.Field id="form-field-changePassword-b">
                    <label id="new-password-changePassword">New password</label>
                    <input
                        id="input-changePassword-b"
                        name="newPassword1"
                        value={changePasswordDto.newPassword1}
                        type="password"
                        onChange={handleChangeInput}
                    />
                </Form.Field>
                <Form.Field id="form-field-changePassword-c">
                    <label id="repeat-password-changePassword">Repeat new password</label>
                    <input
                        id="input-changePassword-c"
                        name="newPassword2"
                        value={changePasswordDto.newPassword2}
                        type="password"
                        onChange={handleChangeInput}
                    />
                </Form.Field>
            </Form>
            <Popup
                content={
                    changePasswordDto.newPassword1 !== changePasswordDto.newPassword2
                        ? "Passwords do not match"
                        : ""
                }
                trigger={
                    <Button
                        id="button-changePassword-a"
                        type="submit"
                        onClick={handleUpdatePassword}
                        content="Change password"
                        primary
                        fluid
                        disabled={!isEnabled || saving}
                        loading={saving}
                    />
                }
            />
        </div>
    );
};
